__turbopack_context__.v({
  "AddMediaButton": "post-message-input-module__1nPFvW__AddMediaButton",
  "FooterOperations": "post-message-input-module__1nPFvW__FooterOperations",
  "TextArea": "post-message-input-module__1nPFvW__TextArea",
  "VideoCover": "post-message-input-module__1nPFvW__VideoCover",
});
